<script setup>
    import { useI18n } from 'vue-i18n';
    import OrderingCodesShop from "./OrderingCodesShop.vue";
    import IconLifecycle from "./IconLifecycle.vue";
    import { computed, onMounted, ref } from 'vue';
    import axios from "../../../setup/axios";
    import { strSlug } from '../../../helpers/strSlug';
    import { getCookie, setCookie } from "../../../helpers/cookiesHelper";
    import StateIcon from "./StateIcon.vue";

    const { t } = useI18n();

    const props = defineProps({
        data: {
            type: Object,
            default: null,
        },

        index: {
            type: String,
            default: null,
        },

        shops: {
            type: Object,
            default: null,
        },

        productHeadline: {
            type: String,
            default: null,
        },

        shopTitleLevelClass: {
            type: String,
            default: null,
        },

        productBrand: {
            type: String,
            default: null,
        },

    });

    const link = computed(() => {
        let link = "/support/technical-support-form?category=sample-request";
        if(props.productHeadline !== null && props.productHeadline != "") {
            link = link + "&productHeader=" + strSlug(props.productHeadline);
        }
        if(props.data.productType !== null && props.data.productType != "") {
            link = link + "&productType=" + props.data.productType;
        }
        return link;
    });

    const currentShops = computed(() => {
        let currentShops = null;
        if(props.shops !== null && props.index !== null && props.shops[props.index] !== null) {
            currentShops = props.shops[props.index];
        }
        return currentShops;
    });

    const showBuyNowButton = computed(() => {
        let currentShops = null;
        if(props.shops !== null && props.index !== null && props.shops[props.index] !== null) {
            currentShops = props.shops[props.index];
        }
        return currentShops.length > 0;
    });

    const currentUrl = window.location.href;

    const currentCart = ref([]);

    function onBuyNowButtonClick(event) {
        let popup = null;
        let isActive = false;

        if(event.target.nodeName !== "A") {
            popup= event.target.closest('a.show-shops').parentElement.querySelector(".popup-container");
        } else {
            popup = event.target.parentElement.querySelector(".popup-container");
        }

        if(popup !== null && popup !== undefined) {
            isActive = popup.classList.contains("is-active");
        }

        document.querySelectorAll(".product-ordering-container .popup-container").forEach(popup => {
           popup.classList.remove("is-active");
        });

        if(!isActive && popup !== null && popup !== undefined) {
            popup.classList.add("is-active");
        }
    }

    function onAmsOsramButtonClick(isSample) {
        let $link = null;
        if(isSample) {
            $link = document.querySelector('.' + props.data.productType + ' .request-sample');
        } else {
            $link = document.querySelector('.' + props.data.productType + ' .has-prices .shop-link');
        }
        if($link !== null && $link !== undefined) {
            if (window.dataLayer) {
                dataLayer.push({
                    event: 'clickedDistributorLink',
                    'shop-name': 'ams OSRAM',
                    'product-name': props.data.productType,
                });
            }
            if (window.Liferay.ThemeDisplay.isSignedIn() !== true) {
                let cookie = getCookie('LOGIN-REDIRECT-URL');
                if (!cookie || cookie.split("=")[1] !== currentUrl) {
                    setCookie('LOGIN-REDIRECT-URL', currentUrl, 30);
                }
                window.location.href = '/c/portal/login';
                return;
            }

            $link.classList.add('is-loading');
            $link.setAttribute('disabled', 'disabled');
            if(isSample) {
                $link.setAttribute( 'rel','nofollow');
            }

            let isAlreadyInCart = false;
            currentCart.value.forEach(element => {
                if(element.ManufacturerPartNumber == props.data.productType) {
                    isAlreadyInCart = true;
                }
            });

            if(!isAlreadyInCart) {
                currentCart.value.push({
                    ManufacturerPartNumber: props.data.productType,
                    Quantity: 1,
                    IsSample: isSample,
                });
            }

            axios
                .post(
                    '/o/shop/checkout',
                    {
                        CartItems: currentCart.value,
                    },
                    {
                        responseType: 'json',
                    }
                )
                .then(response => {
                    if (
                        response.status === 200 &&
                        response.data !== null &&
                        response.data !== undefined &&
                        response.data.RedirectURL !== null &&
                        response.data.RedirectURL !== undefined
                    ) {
                        if(window.sessionStorage.getItem('mouser-popup-presented') === null ){
                            showInfoPopup(document.querySelector('.' + props.data.productType), response);
                        } else {
                            window.location.href = response.data.RedirectURL;
                        }

                    } else {
                        console.error('Error by redirect!');
                    }
                })
                .catch(errorResponse => {
                    console.error(errorResponse);
                })
                .finally(() => {
                    $link.removeAttribute('disabled');
                    $link.classList.remove('is-loading');
                });
        }
    };

    function showInfoPopup($currentProduct, response){
        let $triggerPopUp = $currentProduct.querySelector(
            '.product-status > .link-container > .popup-container'
        );
        let $triggerMouserPopUp = $currentProduct.querySelector(
            '.product-status > .link-container > .popup-mouser-dialog'
        );

        $triggerPopUp.classList.remove('is-active');
        $triggerMouserPopUp.classList.add('is-active');
        setTimeout(() => {
            $triggerMouserPopUp.classList.remove('is-active');
            window.sessionStorage.setItem('mouser-popup-presented', true);
            window.location.href = response.data.RedirectURL;
        }, 8000);
    };

    const showBuyFromAms = ref(false);
    const priceList = ref([]);

    onMounted(() => {
        const checkWhiteLabelShops = props.productBrand === "ams";

        let cookie = getCookie('LOGIN-REDIRECT-URL');
        if (cookie && cookie.split("=")[1] === currentUrl) {
            window.location.href = window.location.href + "#OrderingCodes";
        }

        if (checkWhiteLabelShops) {
            axios
                .get('/o/shop/getCart')
                .then(response => {
                    if (!Object.hasOwn(response.data, 'CartItems')) {
                        return;
                    }
                    currentCart.value = [];
                    if (
                        response.data !== undefined &&
                        response.data !== null &&
                        response.data.CartItems !== undefined &&
                        response.data.CartItems !== null
                    ) {
                        [...response.data.CartItems].forEach(item => {
                            currentCart.value.push({
                                ManufacturerPartNumber: item.ManufacturerPartNumber,
                                Quantity: item.Quantity,
                                IsSample: item.IsSample,
                            });
                        });
                    }
                })
                .catch(error => console.error(error));
        }

        if (checkWhiteLabelShops) {
            let showExampleButton = false;
            let showBuyButton = false;
            axios
                .post(
                    '/o/shop/getProduct',
                    {
                        ManufacturerPartNumber: props.data.productType,
                    },
                    {
                        responseType: 'json',
                    }
                )
                .then(response => {
                    if (
                        response.status === 200 &&
                        response.data !== null &&
                        response.data !== undefined &&
                        response.data.ProductInfo !== undefined &&
                        response.data.ProductInfo !== null &&
                        !response.data.Errors.length
                    ) {
                        const productData = response.data.ProductInfo;
                        let prices = null;

                        if (productData.StockQuantity !== undefined && productData.StockQuantity !== null) {
                            prices = productData.PriceBreaks;
                        }

                        if (
                            productData.StockQuantity !== undefined &&
                            productData.StockQuantity !== null &&
                            parseInt(productData.StockQuantity) > 0
                        ) {
                            productData.PriceBreaks.forEach(Prices => {
                                if (
                                    Prices.Quantity !== undefined &&
                                    Prices.Quantity !== null &&
                                    Prices.Price !== undefined &&
                                    Prices.Price !== null
                                ) {
                                    if (Prices.Quantity === 1) {
                                        showBuyButton = true;

                                        if (Prices.Price < 50) {
                                            showExampleButton = true;
                                        }
                                    }
                                    return;
                                }
                            });

                            showBuyFromAms.value = true;
                            priceList.value = prices;
                        }
                    } else {
                        console.error(
                            'An error occurred while trying to fetch product variant ' +
                            props.data.productType +
                            ' from the shop!'
                        );

                        if (response.data.Errors && response.data.Errors.length) {
                            console.warn(response.data.Errors);
                        }
                    }
                })
                .catch(errorResponse => {
                    console.error(errorResponse);
                    console.error('No products available! Please check back again in a few minutes.');
                });
        }
    });

</script>

<template>
    <tr v-if="data !== null" class="product-container" :class="data.productType">
        <td class="product-type" :data-label="t('productDetails.Ordering.Codes.TableTitle.Type')">
            {{ data.productType }}
        </td>
        <td class="product-description" :data-label="t('productDetails.Ordering.Codes.TableTitle.Description')">
            <span v-html="data.description"></span>
        </td>
        <td class="product-order-nr" :data-label="t('productDetails.Ordering.Codes.TableTitle.Order')">
            {{ data.orderNumber }}
        </td>
        <td class="product-status">
            <div class="link-container">
                <div class="icons-container">
                    <IconLifecycle :icon-class="data.status"/>
                    <div class="icon-description-container">
                        <span class="title " :class="shopTitleLevelClass">
                            {{ t('productDetails.Ordering.Codes.Description.Popup.Headline') }}
                        </span>
                        <StateIcon icon-order-code="10" text="productDetails.Ordering.Codes.Description.full-production" />
                        <StateIcon icon-order-code="03" text="productDetails.Ordering.Codes.Description.preliminary" />
                        <StateIcon icon-order-code="91" text="productDetails.Ordering.Codes.Description.not-for-new-design" />
                        <StateIcon icon-order-code="95" text="productDetails.Ordering.Codes.Description.orders-still-accepted" />
                        <StateIcon icon-order-code="99" text="productDetails.Ordering.Codes.Description.discontinued" />
                    </div>
                </div>


                <a v-if="!showBuyNowButton" :href="link" class="contact-us button is-secondary">
                    {{ t('productDetails.Ordering.Codes.BuyNow.empty') }}
                </a>

                <a v-if="showBuyNowButton" class="show-shops button is-primary" @click="onBuyNowButtonClick($event)">
                    <svg class="icon icon-cart">
                        <use xlink:href="#icon-cart" />
                    </svg>
                    {{ t('productDetails.Ordering.Codes.BuyNow') }}
                </a>
                <div v-if="showBuyNowButton" class="top-arrow-icon"></div>
                <div v-if="showBuyNowButton" class="popup-mouser-dialog">
                    {{ t('mouserRedirectMessage') }}
                </div>
                <div v-if="showBuyNowButton" class="popup-container">
                    <div v-if="showBuyFromAms" class="shops white-label-shops">
                        <div class="shops-title">{{ t('productDetails.Ordering.Codes.BuyFromAmsOsram') }}</div>
                        <div class="shop has-prices">
                            <a title="ams OSRAM" target="_blank" class="shop-link button is-primary" rel="nofollow" href="" @click.prevent="onAmsOsramButtonClick(false)">
                                <svg class="icon icon-cart">
                                    <use xlink:href="#icon-cart"></use>
                                </svg>
                                {{ t('productDetails.Ordering.Codes.BuyNow') }}
                            </a>
                            <div class="prices">
                                <div v-for="price in priceList" class="element">
                                    <div class="unit"> {{ price.Quantity }}</div>
                                    <div class="price">{{ price.Price }}/unit</div>
                                </div>
                            </div>
                        </div>
                        <div class="shop">
                            <a title="Sample" target="_blank" class="shop-link button is-secondary is-darker request-sample" rel="nofollow" href="" @click.prevent="onAmsOsramButtonClick(true)">
                                {{ t('prodDetail_RequestFreeSample') }}
                            </a>
                        </div>
                    </div>
                    <div v-if="currentShops" class="shops">
                        <div class="shops-title">
                            {{ t('productDetails.Ordering.Codes.Popup.Distribution.Partners') }}
                        </div>
                        <OrderingCodesShop v-for="(modalShop) in currentShops" :modal-shop="modalShop" :shop-title-level-class="shopTitleLevelClass" :product-type="data.productType" />
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<style lang="scss">
    @import '../../../../scss/variables';
    @import '../../../../scss/utilities/all';
    @import '../../../../scss/forms/_all.scss';

    .icon-description-container {
        &visible {
            opacity: 1;
            visibility: visible;
        }
    }

</style>
